import React, { createContext, useContext, useState, ReactNode } from "react";
import axios from "axios";
import { AuthContextType, LoginResponse } from "../../services/dto/auth";

const AuthContext = createContext<AuthContextType | undefined>(undefined);

const loginApi = async (
  loginEmail: string,
  passwd: string
): Promise<LoginResponse> => {
  try {
    const response = await axios.post("/scb-laundry/public/login", {
      loginEmail,
      passwd,
    });

    if (response.status === 200) {
      return response.data as LoginResponse;
    } else {
      throw new Error(`Login failed with status: ${response.status}`);
    }
  } catch (error: any) {
    console.error(
      "Error during login API call:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.message || "Login failed");
  }
};

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginData, setLoginData] = useState<LoginResponse | null>(null);

  const login = async (email: string, password: string) => {
    try {
      const response = await loginApi(email, password);
      setLoginData(response);
      setIsAuthenticated(true);
    } catch (error) {
      console.error("Login failed:", error);
      throw error;
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setLoginData(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, loginData, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
